import ClinicTemplates from './templates'

export const validateClinicFormFields = (unfilledFields, recordData) => {
  const fieldsToValidate = {
    1: [
      ClinicTemplates.dataModel.name.key,
      ClinicTemplates.dataModel.clinicType.key,
      ClinicTemplates.dataModel.paymentMethods.key,
      ClinicTemplates.dataModel.termsConditions.key
    ],
    2: [
      ClinicTemplates.dataModel.province.key,
      ClinicTemplates.dataModel.address.key,
      ClinicTemplates.dataModel.physicalAddress.key,
      ClinicTemplates.dataModel.email.key,
      ClinicTemplates.dataModel.phoneNumber.key
    ],
    3: [
      ClinicTemplates.dataModel.bpmConfig.key,
      ClinicTemplates.dataModel.practiceName.key,
      ClinicTemplates.dataModel.practiceRegNumber.key,
      ClinicTemplates.dataModel.practiceNumber.key
    ],
    4: [], // Services Offered - no required fields (optional)
    5: [], // Configure Services - no required fields (optional)
    6: [
      ['billingProfile', 'disciplineType'],
      ['billingProfile', 'schemeContracts'],
      ['billingProfile', 'disciplinePrefix'],
      ['billingProfile', 'roomsDefault']
    ], // Billing Profile - required fields
    7: [] // Billing Macros - no required fields
  }

  const newUnfilledFields = { ...unfilledFields }

  Object.keys(fieldsToValidate).forEach((tabKey) => {
    const fields = fieldsToValidate[tabKey]

    newUnfilledFields[tabKey] = fields.reduce((count, field) => {
      let value

      // Handle nested keys (arrays) vs direct keys (strings)
      if (Array.isArray(field)) {
        // For nested keys like ['billingProfile', 'disciplineType']
        // Access recordData.billingProfile.disciplineType
        value = field.reduce((obj, key) => {
          return obj && obj[key]
        }, recordData)
      } else {
        // For direct keys like 'name'
        value = recordData[field]
      }

      return count + (value ? 0 : 1)
    }, 0)
  })

  return newUnfilledFields
}

export const basicInfoValid = (recordData, newRecord) =>
  !(!recordData?.name || !recordData?.clinicType || !recordData?.paymentMethods || !recordData?.termsConditions) ||
  !newRecord

export const locationDataValid = (recordData, newRecord) =>
  !(
    !recordData?.address ||
    !recordData?.email ||
    !recordData?.place_id ||
    !recordData?.province ||
    !recordData?.phoneNumber
  ) || !newRecord

export const practiceDetailsDataValid = (recordData, newRecord) =>
  !(
    !recordData?.practiceName ||
    !recordData?.practiceRegNumber ||
    !recordData?.practiceNumber ||
    !recordData?.bpmKey ||
    recordData?.bpmConfig?.length === 0
  ) || !newRecord

export const servicesOfferedDataValid = (recordData, newRecord) => {
  return !(!recordData?.servicesOffered || recordData?.servicesOffered?.length === 0) || !newRecord
}
export const servicesConfigDataValid = (recordData, newRecord) => {
  // If it's not a new record, skip validation
  if (!newRecord) {
    return true
  }

  // Check if servicesConfig exists and has length > 0
  if (!recordData?.servicesConfig || recordData?.servicesConfig?.length === 0) {
    return false
  }

  // Check that every service offered has a corresponding service configuration
  const servicesOfferedIds = recordData.servicesOffered || []
  const servicesConfig = recordData.servicesConfig || []
  const configuredServiceRefs = servicesConfig.map((config) => config.serviceRef)

  // Find services that are offered but not configured
  const unconfiguredServices = servicesOfferedIds.filter((serviceId) => !configuredServiceRefs.includes(serviceId))

  // Return false if there are unconfigured services
  if (unconfiguredServices.length > 0) {
    console.warn('Validation failed: Some services are offered but not configured:', unconfiguredServices)
    return false
  }

  return true
}

export const billingProfileDataValid = (recordData, newRecord) => {
  return (
    !(
      // No profile object
      (
        !recordData?.billingProfile ||
        // No discipline type
        !recordData?.billingProfile?.disciplineType ||
        // No rooms default
        !recordData?.billingProfile?.roomsDefault ||
        // No discipline prefix
        !recordData?.billingProfile?.disciplinePrefix ||
        // No scheme contracts or scheme contracts is empty
        !recordData?.billingProfile?.schemeContracts ||
        recordData?.billingProfile?.schemeContracts?.length === 0
      )
      // Isn't a new record and validation gets handled on individual forms
    ) || !newRecord
  )
}

export const billingMacrosDataValid = (recordData, newRecord) => !recordData?.billingMacros || !newRecord
